import { viewId, table, restApiKey } from '../../../../_constants/Code'
import { PathInfoList } from '../../../../_constants/PathInfoList'
import { getDynamoDB } from '../../../../common/utils/DynamoDbUtils'
import { httpPost } from '../../../../services/api/AmplifyApi'

import '../extra/types'

export async function fetchMaster(corporationNumber) {
  let master = await getDynamoDB(
    table.Master,
    null,
    corporationNumber,
    { CorporationNumber: corporationNumber, MasterId: viewId.categoryInfo },
    null
  )
  return master[0]
}

export async function fetchCategory(corporationNumber) {
  let category = await getDynamoDB(
    table.Category,
    null,
    corporationNumber,
    { CorporationNumber: corporationNumber },
    null
  )
  category.sort((a, b) => {
    const aVal = Number(a.Sort)
    const bVal = Number(b.Sort)

    const aValid = !isNaN(aVal) && aVal >= 1
    const bValid = !isNaN(bVal) && bVal >= 1

    if (aValid && bValid) {
      return aVal - bVal // 両方有効なら昇順
    } else if (aValid) {
      return -1 // aは有効なので前
    } else if (bValid) {
      return 1 // bは有効なので前
    } else {
      return 0 // 両方無効なら順序維持
    }
  })
  return category
}

export async function fetchCategoryTag(corporationNumber) {
  let categoryTag = await getDynamoDB(
    table.CategoryTag,
    null,
    corporationNumber,
    { CorporationNumber: corporationNumber },
    null
  )
  return categoryTag
}

export async function updateCategory(corporationNumber, corporationName, userName, userSub, payload) {
  const requestPayload = {
    corporation_number: corporationNumber,
    corporation_name: corporationName,
    user_name: userName,
    user_sub: userSub,
    table_data: payload
  }

  const init = {
    headers: {},
    body: requestPayload
  }

  return httpPost(restApiKey.CHROFY_REST_API, PathInfoList.Resource.updateCategory(corporationNumber), init)
}
